<template>
  <div class="card green">
    <div class="content">
      <div class="header">
        {{ $t('INTERCEPT_EVENT') }}
        <i class="right floated mouse pointer icon"></i>
      </div>
      <div
        class="meta"
        v-html="
          $t('INTERCEPT_META', {
            eventType: trigger.configuration.eventType,
            fieldId: trigger.configuration.fieldId,
            fieldName: nameOfField(trigger.configuration.fieldId)
          })
        "
      ></div>
    </div>
    <div class="primary content">
      <div class="ui tiny negative message" v-if="errorMessage">
        <i class="bullhorn icon"></i>
        {{ errorMessage }}
      </div>
      <div class="grouped field">
        <label>{{ $t('INTERCEPT_EVENTTYPE') }}</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input
              type="radio"
              class="hidden"
              :id="'LEFTCLICK-' + triggerIndex"
              value="LEFTCLICK"
              v-model="trigger.configuration.eventType"
            />
            <label :for="'LEFTCLICK-' + triggerIndex">
              {{ $t('INTERCEPT_LEFTCLICK') }}
            </label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input
              type="radio"
              class="hidden"
              :id="'RIGHTCLICK-' + triggerIndex"
              value="RIGHTCLICK"
              v-model="trigger.configuration.eventType"
            />
            <label :for="'RIGHTCLICK-' + triggerIndex">
              {{ $t('INTERCEPT_RIGHTCLICK') }}
            </label>
          </div>
        </div>
      </div>
      <div class="field">
        <typeahead
          :multiple="false"
          :current-item="currentField"
          :items="interceptableFields"
          :label-text="$tc('FIELD', 1)"
          :placeholder-text="$tc('FIELD', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('FIELD', 2) })"
          :select-handler="fieldSelected"
          :disabled="isEditDisabled"
        >
          <template slot="selected" slot-scope="props">
            <span class="description">{{ nameOfApp(props.item.application) }}</span>
            <span class="text">{{ props.item.name }}</span>
          </template>
          <template slot="dropdown" slot-scope="props">
            <span class="description">{{ nameOfApp(props.item.application) }}</span>
            <span class="text">{{ props.item.name }}</span>
          </template>
        </typeahead>
      </div>

      <!-- allowOutsideWindow and allowUnfocused settings for native apps -->
      <template v-if="app && app.type === 'NATIVE'">
        <div class="field">
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              class="hidden"
              :id="'ALLOWOUTSIDEWINDOW' + triggerIndex"
              value="ALLOWOUTSIDEWINDOW"
              v-model="trigger.configuration.allowOutsideWindow"
            />
            <label :for="'ALLOWOUTSIDEWINDOW' + triggerIndex">
              {{ $t('INTERCEPT_ALLOWOUTSIDEWINDOW') }}
            </label>
          </div>
        </div>

        <div class="field">
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              class="hidden"
              :id="'ALLOWUNFOCUSED' + triggerIndex"
              value="ALLOWUNFOCUSED"
              v-model="trigger.configuration.allowUnfocused"
            />
            <label :for="'ALLOWUNFOCUSED' + triggerIndex">
              {{ $t('INTERCEPT_ALLOWUNFOCUSED') }}
            </label>
          </div>
        </div>
      </template>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'
import _ from 'lodash'
import { Typeahead, Typenames } from 'ui'
import { map } from 'rxjs/operators'
import { ActionTypes } from 'store'

export default {
  name: 'eventintercepttrigger',
  components: { Typeahead },

  props: {
    triggerIndex: Number,
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            eventType: '',
            fieldId: ''
          }
        }
      }
    }
  },

  data() {
    return {
      app: null
    }
  },

  computed: {
    allApps() {
      return this.$store.state.application.items
    },
    allFlows() {
      return this.$store.state.flow.items
    },
    allFields() {
      return this.$store.state.field.items
    },
    currentField() {
      const fieldId = this.trigger.configuration.fieldId
      return this.nameOfField(fieldId)
    },
    interceptableFields() {
      return _.filter(this.allFields, field => field.path && !field.path.startsWith('@'))
    },
    isEditDisabled() {
      return this.$store.state.flowEditor.isFlowEditingDisabled
    },
    errorMessage() {
      if (!this.trigger.configuration || !this.trigger.configuration.eventType) {
        return this.$i18n.t('INTERCEPT_NO_EVENTTYPE')
      }
      if (!this.trigger.configuration.fieldId) {
        return this.$i18n.t('INTERCEPT_NO_FIELD')
      }
      return null
    }
  },

  methods: {
    fieldSelected(field: Object) {
      this.trigger.configuration.fieldId = field.id
      this.app = _.find(this.allApps, app => app.id == field.application)
      if (!this.app || this.app.type !== 'NATIVE') {
        delete this.trigger.configuration.allowOutsideWindow
        delete this.trigger.configuration.allowUnfocused
      }
    },

    nameOfField(fieldId: string): string {
      let field = _.find(this.allFields, field => field.id === fieldId)
      return (field && field.name) || fieldId
    },

    nameOfApp(appId: string): string {
      let app = _.find(this.allApps, app => app.id === appId)
      return (app && app.name) || appId
    }
  },

  created() {}
}
</script>
